<h1 class="text-5xl font-medium text-center mb-4 mt-4">Thanks!</h1>
<p class="text-center text-lg mb-10">We've successfully registered <span class="font-medium">{{email}}</span> for our waiting list, we'll keep you up-to-date.</p>
<a pButton class="mt-auto" [routerLink]="['/']" [replaceUrl]="true">Home</a>
